// Module
var code = `<template> <div class="comp-toggle"> <template repeat.for="option of options"> <div id="\${id}" class="option \${selectedOption === option ? 'is-selected' : ''}" click.trigger="selectOption(option)" if.bind="option.show">\${option.title}</div> </template> </div> </template>`;
// Exports
module.exports = code;